import { render, staticRenderFns } from "./payment-tab.vue?vue&type=template&id=16206150&"
import script from "./payment-tab.vue?vue&type=script&lang=js&"
export * from "./payment-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports